module.exports = __webpack_public_path__ + "img/noBiao.6e386dbe.png";